import { Component } from '@theme/component';

/**
 * Buy Now button — adds the currently-selected product to cart and redirects
 * straight to checkout, skipping the cart drawer.
 *
 * Lives inside the same <product-form-component> as the regular ATC, so it has
 * access to all the same hidden inputs (variant id, selling_plan, quantity, etc).
 * Submits a FormData of the surrounding <form> to /cart/add.js, then navigates
 * to /checkout on success. Any Shopify cart-level discount applied for the
 * session (e.g. via /discount/CODE) is automatically respected at checkout.
 */
class BuyNowComponent extends Component {
  /**
   * Click handler. Bound declaratively via on:click="/handleClick" on the button.
   * @param {Event} event
   */
  async handleClick(event) {
    event?.preventDefault?.();

    const button = /** @type {HTMLButtonElement} */ (this.refs.buyNowButton);
    if (!button) return;
    const form = button.closest('form');
    if (!form) return;

    if (button.disabled) return;
    button.disabled = true;
    button.classList.add('is-loading');

    try {
      const formData = new FormData(form);
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/javascript' },
      });
      if (!response.ok) throw new Error(`cart/add failed with ${response.status}`);
      window.location.href = '/checkout';
    } catch (err) {
      console.error('[buy-now-component] add-to-cart failed:', err);
      button.disabled = false;
      button.classList.remove('is-loading');
    }
  }
}

if (!customElements.get('buy-now-component')) {
  customElements.define('buy-now-component', BuyNowComponent);
}
